import React from "react";
import { X } from "lucide-react";

export function errMsg(e) {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    return e?.message || "Something went wrong.";
}

export function fmtDate(iso) {
    if (!iso) return "—";
    return new Date(iso).toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function Modal({ title, onClose, children, wide, testid }) {
    return (
        <div className="fixed inset-0 bg-black/40 z-50 grid place-items-center p-3 sm:p-6" data-testid={testid}>
            <div className={`w-full ${wide ? "max-w-4xl" : "max-w-lg"} max-h-[92vh] flex flex-col bg-white rounded-lg border border-lnl-border shadow-2xl`}>
                <div className="flex items-center justify-between px-5 py-3 border-b border-lnl-border">
                    <div className="font-heading font-bold text-lnl-charcoal">{title}</div>
                    <button onClick={onClose} className="p-1.5 rounded hover:bg-lnl-off-white" aria-label="Close" data-testid={`${testid || "modal"}-close`}><X className="h-4 w-4" /></button>
                </div>
                <div className="p-5 overflow-y-auto">{children}</div>
            </div>
        </div>
    );
}

export function Field({ label, children, hint }) {
    return (
        <label className="block">
            <span className="text-xs text-lnl-gray font-heading font-semibold">{label}</span>
            <div className="mt-1">{children}</div>
            {hint && <span className="text-[11px] text-lnl-gray mt-1 block">{hint}</span>}
        </label>
    );
}

export const inputCls = "w-full rounded-md border border-lnl-border px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-lnl-green/30";

const TONES = {
    Sent: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Failed: "bg-red-50 text-red-700 border-red-200",
    Retrying: "bg-amber-50 text-amber-700 border-amber-200",
    Pending: "bg-amber-50 text-amber-700 border-amber-200",
    Inactive: "bg-gray-100 text-gray-600 border-gray-200",
    Archived: "bg-gray-100 text-gray-500 border-gray-200",
    Disabled: "bg-gray-100 text-gray-600 border-gray-200",
    Default: "bg-lnl-green-bg text-lnl-green-deep border-lnl-green/30",
};

export function Pill({ value, testid }) {
    return <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-heading font-semibold ${TONES[value] || "bg-gray-50 text-gray-600 border-gray-200"}`}>{value}</span>;
}

export function Toggle({ checked, onChange, label, testid, disabled }) {
    return (
        <label className={`flex items-center justify-between gap-4 py-2 ${disabled ? "opacity-50" : ""}`}>
            <span className="text-sm text-lnl-charcoal">{label}</span>
            <button type="button" role="switch" aria-checked={checked} disabled={disabled} onClick={() => onChange(!checked)} data-testid={testid}
                className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${checked ? "bg-lnl-green" : "bg-gray-300"}`}>
                <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-5" : "translate-x-0.5"}`} />
            </button>
        </label>
    );
}

export function EmailFrame({ html, testid }) {
    return <iframe title="Email preview" sandbox="" srcDoc={html} className="w-full h-[460px] rounded-md border border-lnl-border bg-white" data-testid={testid} />;
}
